import { gql } from '@apollo/client';
import { graphql } from '@apollo/client/react/hoc';
import { Vehicle } from '@sm360/widget-commons-vehicle';
import GarageVehicle from 'commons-garage/components/GarageVehicle/GarageVehicle.jsx';
import { compose } from 'redux';
import isEmpty from 'lodash/isEmpty';

const { VehicleService } = Vehicle;

const QUERY_USED = gql`
    query fetchUsedVehicle($id: Int!) {
        vehicle(id: $id) {
            id
            flags {
                label
                type
            }
            make {
                name
                id
            }
            model {
                name
                id
            }
            year
            odometer
            characteristics {
                transmission {
                    label
                    type
                    driveTrain {
                        label
                    }
                }
                engine {
                    description
                }
            }
            prices {
                sale
                regular
            }
            multimedia {
                mainPicture {
                    url
                }
            }
            stockNo
            sold
            onHold
            online
        }
    }
`;

const QUERY_NEW = gql`
    query fetchNewVehicle($id: Int!) {
        newVehicle(id: $id) {
            stockNo
            sold
            onHold
            online
        }
    }
`;

function getOptions(props) {
    return {
        variables: {
            id: props.vehicleId,
            forceUpdate: props.forceVehiclesFetch,
        },
        fetchPolicy: 'no-cache',
    };
}

function getUsedProps(props) {
    const {
        data: { vehicle, loading },
    } = props;

    const vehicleModel =
        !loading && vehicle
            ? VehicleService.resetVehicleV25FromWebAutoInventory(vehicle)
            : new Vehicle.VehicleModelV25();
    return {
        vehicle: vehicleModel,
    };
}

function getNewProps(props) {
    const {
        data: { newVehicle, loading },
        ownProps,
    } = props;

    let vehicleModel;

    if (!loading && newVehicle) {
        const { vehicle } = ownProps.quote;
        vehicleModel = vehicle
            .set('sold', newVehicle.sold)
            .set('onHold', newVehicle.onHold)
            .set('stockNumber', newVehicle.stockNo)
            .set('online', newVehicle.online);
    } else {
        vehicleModel = new Vehicle.VehicleModelV25();
    }

    return {
        vehicle: vehicleModel,
    };
}

const fetchUsedVehicle = graphql(QUERY_USED, {
    alias: 'fetchUsedVehicle',
    options: getOptions,
    props: getUsedProps,
    skip: (props) => !props.vehicleId,
});

const fetchNewVehicle = graphql(QUERY_NEW, {
    alias: 'fetchNewVehicle',
    options: getOptions,
    props: getNewProps,
    skip: (props) => isEmpty(props.vehicleId) || props.vehicleId !== 0,
});

export default compose(
    fetchUsedVehicle,
    fetchNewVehicle
)(GarageVehicle);
